import { newComposicao } from "./composicao.domain";

class Produto {

    constructor(props){
        const {composicao, ...produtosProps} = props;
        this.props = produtosProps;
        this.props.composicao = [];
        // if(composicao && composicao.length){
        //     this.props.composicao = composicao.map(comp => {
        //         const {uuid, quantidadeUtilizada, codigo="", descricao=""} = comp;
        //         const produtoComposicao = newProduto({
        //             uuid: comp.produto || comp.uuidProduto,
        //             codigo, descricao
        //         });

        //         return newComposicao({
        //             quantidadeUtilizada, uuid,
        //             produto: produtoComposicao,
        //         })})
        // }else {
            
        // }
    }

    get composicao(){
        return this.props.composicao;
    }

    hasId(){
        return this.props.id? true: false;
    }

    removeComposicaoDoProduto(composicao){
        let newComposicao = [].concat(...this.props.composicao);
        let indice = newComposicao.findIndex(comp => comp.equals(composicao));
        if(indice >= 0){
            newComposicao.splice(indice, 1);
            this.props = Object.assign({}, this.props, {composicao: newComposicao});
        }


    }

    addComposicao(composicao){
        const newComposicao = [].concat(...this.props.composicao);
        
        newComposicao.push(composicao);
        this.props = Object.assign({}, this.props, {composicao: newComposicao});

    }

    fillNCM(ncmObject){
        const {codigo:ncm, porcentagemAproximadaImpostos} = ncmObject;
        this.props = Object.assign({}, this.props, {ncm, porcentagemAproximadaImpostos});
        
    }

    _calculaValorUTrib(newProps){

        const {fatorCorrecaoUnidadeMedidaTrib, vUnCom, uTrib, uCom} = newProps;

        if(!fatorCorrecaoUnidadeMedidaTrib || fatorCorrecaoUnidadeMedidaTrib <=0 || !vUnCom || vUnCom <= 0 || uTrib == uCom || !uTrib){
            return vUnCom;
        }
    
        let vUnTrib = vUnCom / fatorCorrecaoUnidadeMedidaTrib;
        vUnTrib = parseFloat(vUnTrib.toFixed(6));
        return vUnTrib;
        
    }

    _calculaValorPrecoEcommerce(newProps){
        return newProps.vUnCom / newProps.fatorCorrecaoUnidadeEcommerce;
    }

    

    fillVUnCom(vUnCom){
        vUnCom = this._normalizaValor(vUnCom);

        const newProps = Object.assign({}, this.props, {vUnCom});

        newProps.vUnTrib = this._calculaValorUTrib(newProps);

        if(newProps.valorCusto){
            newProps.markup = ((newProps.vUnCom - newProps.valorCusto) / newProps.valorCusto) * 100;
            newProps.markup = parseFloat(newProps.markup.toFixed(6));
        }
    
        if(newProps.fatorCorrecaoUnidadeEcommerce){
            newProps.precoEcommerce = this._calculaValorPrecoEcommerce(newProps);
        }

        this.props = newProps;
        
    }

    fillMarkup(markup){
        
        let newProps = Object.assign({}, this.props, {markup});
        
        this.props = newProps; 

        if(markup && newProps.valorCusto){
            let valorUn = newProps.valorCusto * (1 + newProps.markup / 100);
            valorUn = this._normalizaValor(valorUn);
            this.fillVUnCom(valorUn);
        }

        
    }

    fillValorCusto(valorCusto){
        
        let newProps = Object.assign({}, this.props, {valorCusto});

        this.props = newProps;
        
        if(newProps.markup && newProps.markup > 0 && valorCusto){
            
            let valorUn = newProps.valorCusto * (1 + newProps.markup / 100);
            valorUn = this._normalizaValor(valorUn);


            this.fillVUnCom(valorUn);
            
        }

    }

    fillUtrib(uTrib){
        const newProps = Object.assign({}, this.props, {uTrib});

        if(uTrib && uTrib != newProps.uCom){

            const vUnTrib = this._calculaValorUTrib(newProps);
            newProps.vUnTrib = vUnTrib;
        }
        
        this.props = newProps; 
    }

    __calculaFatorCorrecao(){

    }

    fillVUnTrib(vUnTrib){
        const newProps = Object.assign({}, this.props, {vUnTrib});

        let fatorCorrecaoUnidadeMedidaTrib =  newProps.vUnCom / vUnTrib;

        fatorCorrecaoUnidadeMedidaTrib = parseFloat(fatorCorrecaoUnidadeMedidaTrib.toFixed(3));

    
        this.props = Object.assign({}, newProps, {fatorCorrecaoUnidadeMedidaTrib});

        
    }

    fillFatorCorrecaoUnidadeTributaria(fatorCorrecaoUnidadeMedidaTrib){
        const newProps = Object.assign({}, this.props, {fatorCorrecaoUnidadeMedidaTrib});

        const {uCom, uTrib} = newProps;
       
        if(uTrib && uTrib != uCom){
            const vUnTrib = this._calculaValorUTrib(newProps);
            newProps.vUnTrib = vUnTrib;
        }

        this.props = newProps;
        
    }

    fillFatorCorrecaoEcommerce(fatorCorrecaoUnidadeEcommerce){
        const newProps = Object.assign({},this.props, {fatorCorrecaoUnidadeEcommerce});

        if(!fatorCorrecaoUnidadeEcommerce){
            newProps.precoEcommerce = "";
        } else {
            newProps.precoEcommerce = this._calculaValorPrecoEcommerce(newProps);

        }

        this.props = newProps;
    }
    
    _normalizaValor = (floatNumber)=>{
        floatNumber = parseFloat(floatNumber.toFixed(8));
        return floatNumber
    }
    

    toPlainJson(){

        const {composicao,  ...jsonProduto } = this.props;
        let jsonComposicao = [];
        if(composicao){
            jsonComposicao = composicao.map(comp => comp.toPlainJson());
        }

        return Object.assign({}, {
            ...jsonProduto,
            composicao: jsonComposicao
        });
    }

    _errosValidacaoCodigo(){
        let codigoStatus = {
            name: "codigo",
            errors: []
        }
        if(!this.props.codigo){
            codigoStatus = newRequiredStatusError('codigo');
        } else if(this.props.codigo.length > 60){
            codigoStatus = newMaxLengthStatusError('codigo', 60);
        }

        
        return codigoStatus;
    }

    _errosValidacaoDescricao(){
        let codigoStatus = {
            name: "descricao",
            errors: []
        }

        if(!this.props.descricao){
            codigoStatus = newRequiredStatusError("descricao")
        }

        return codigoStatus;
    }

    _errosValidacaoNCM(){
        let codigoStatus = {
            name: "ncm",
            errors: []
        }

        if(!this.props.ncm && this.props.tipoProduto != "MATERIA_PRIMA"){
            codigoStatus = newRequiredStatusError("ncm")
        }

        return codigoStatus;
    }

    _errosValidacaoUCom(){
        let codigoStatus = {
            name: "uCom",
            errors: []
        }

        const {uCom} = this.props;

        if(!uCom){
            return newRequiredStatusError("uCom", "Unidade Comercial")
        }

        if(!isNaN(parseFloat(uCom))){
            return  newStatusError("uCom", "Unidade Comercial Inválida");
        }

        if(uCom.length && uCom.length > 15){
            return newMaxLengthStatusError("uCom", 15, "Unidade Comercial");
        }

        return codigoStatus;
    }

    

    _errosValidacaoCampoEAN(validateEANFunc, campo){
        let codigoStatus = {
            name: campo,
            errors: []
        }

        if(this.props[campo]){
            const isValid = validateEANFunc(this.props[campo])
            if(!isValid){
                codigoStatus = newStatusError("eanCom", "O valor do campo EAN Comercial não é um EAN válido");
            }
        }

        return codigoStatus;
    }

  
    fillValue(field){
        const campos = Object.keys(field)
        const newProps = Object.assign({}, this.props);
        for(const campo of campos){
            newProps[campo] = field[campo]
        }
        this.props = newProps;
    }

    toApiJson(){
        let retorno;

        const {
            enviaBalanca,
            imprimeDataValidade,
            imprimeDataEmbalagem,
            diasValidade,
            codigoInformacaoNutricional,
            codigoTara,
            codigoGlaciamento,
            codigoInformacaoExtra, 
            composicao,
            porcentagemImpostosReais: porcentagemImpostosReaisObj,
            valorEstoqueInicial:valorEstoqueInicialObj={},
            estoqueMinimo:estoqueMinimoObj={},
            ...dadosSemBalanca} = this.props;

        const dadosBalanca = {
            enviaBalanca,
            imprimeDataValidade,
            imprimeDataEmbalagem,
            diasValidade,
            codigoInformacaoNutricional,
            codigoTara,
            codigoGlaciamento,
            codigoInformacaoExtra }

        let jsonComposicao = [];
        if(composicao){
            jsonComposicao = composicao.map(comp => comp.toApiJson());
        } 

        const {floatValue:valorEstoqueInicial=0} = valorEstoqueInicialObj;

        const {floatValue:estoqueMinimo=0} = estoqueMinimoObj;

        const {floatValue:porcentagemImpostosReais} = porcentagemImpostosReaisObj || {floatValue: 0};

        


            
        // const jsonComposicao = composicao.map(comp => comp.toApiJson());
 
        retorno = {...dadosSemBalanca, valorEstoqueInicial, estoqueMinimo, dadosBalanca, composicao: jsonComposicao, porcentagemImpostosReais};
        
        return retorno;
    }

    precisaPreencherImpostos(){
        return this.props.ncm 
               && this.props.ncm.length == 8 
               && ( 
                    this.props.porcentagemAproximadaImpostos == undefined 
                    || this.props.porcentagemAproximadaImpostos == null 
                    || this.props.porcentagemAproximadaImpostos == ""
               )
    }

    permiteComposicao() {
        console.log(`this.props.tipoProduto == "PRODUTO_COMPOSTO"` , this.props.tipoProduto == "PRODUTO_COMPOSTO")
        return this.props.tipoProduto == "PRODUTO_COMPOSTO"
    }

    validate(validateEANFunc){

        if(!validateEANFunc){
            throw new Error("Para validar o produto é preciso informar uma funcao de validacao do EAN");
        }

        const status = [];
        
        const errosValidacaoCodigo = this._errosValidacaoCodigo();
        const errosValidacaoDescricao = this._errosValidacaoDescricao();
        const errosValidacaoNcm = this._errosValidacaoNCM();

        const errosValidacaoUCom = this._errosValidacaoUCom();

        const errosValidacaoEANCom = this._errosValidacaoCampoEAN(validateEANFunc, "eanCom");
        const errosValidacaoEANTrib = this._errosValidacaoCampoEAN(validateEANFunc, "eanTrib");
        
        if(errosValidacaoDescricao){
            status.push(errosValidacaoDescricao)
        }

        if(errosValidacaoCodigo){
            status.push(errosValidacaoCodigo)
        }

        if(errosValidacaoNcm){
            status.push(errosValidacaoNcm)
        }

        if(errosValidacaoUCom){
            status.push(errosValidacaoUCom);
        }
        
        if(errosValidacaoEANCom){
            status.push(errosValidacaoEANCom)
        }

        if(errosValidacaoEANTrib){
            status.push(errosValidacaoEANTrib)
        }


        return status;
    }
    
}

const newStatusError = (campo, ...mensages) => {
    return {
        name: campo,
        errors: mensages
    }
}

const newMaxLengthStatusError = (campo, maxLenght, label='') => {
    if(!label){
        label = campo;
    }
    return newStatusError(campo, `O campo ${label} deve ter no máximo ${maxLenght} caracteres`);
}

const newRequiredStatusError = (campo, label='') => {
    if(!label){
        label = campo;
    }

    return newStatusError(campo, `O campo ${label} é obrigatorio`);
}


const newProduto = (dados)=>{
    if(dados){

        const {composicao=[], ...dadosProduto} = dados
        const produto = new Produto(dadosProduto);
        
        for(const c of composicao){
            const {uuid, produto:dadosProdutoCompoe, quantidadeUtilizada} = c;
            
            const produtoCompoe = newProduto(dadosProdutoCompoe)
            const compToAdd = newComposicao({
                produto: produtoCompoe,
                quantidadeUtilizada,
                uuid
            });
    
            produto.addComposicao(compToAdd);
        }
    
        return produto;
    }
    //throw new Error("Deve passar os dados do produto");
    return null;
}




export {Produto, newProduto}